import { useToast } from 'vue-toastification';

/**
 * AURA Toast Composable
 * Provides toast notifications following Mobcall design system
 */
export const useAuraToast = () => {
    const toast = useToast();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const defaultOptions: any = {
        position: 'top-right',
        timeout: 5000,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: false,
        closeButton: 'button',
        icon: true,
        rtl: false,
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const success = (message: string, options?: any) => {
        toast.success(message, {
            ...defaultOptions,
            ...options,
            toastClassName: 'aura-toast-success bg-green-50 border-green-200 text-green-700',
        });
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const error = (message: string, options?: any) => {
        toast.error(message, {
            ...defaultOptions,
            ...options,
            toastClassName: 'aura-toast-error bg-red-50 border-red-200 text-red-700',
        });
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const info = (message: string, options?: any) => {
        toast.info(message, {
            ...defaultOptions,
            ...options,
            toastClassName: 'aura-toast-info bg-blue-50 border-blue-200 text-blue-700',
        });
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const warning = (message: string, options?: any) => {
        toast.warning(message, {
            ...defaultOptions,
            ...options,
            toastClassName: 'aura-toast-warning bg-yellow-50 border-yellow-200 text-yellow-700',
        });
    };

    return {
        success,
        error,
        info,
        warning,
    };
};
